export const core = {
  gift: {
    title: '¡Bienvenido!',
    description: 'Para el registro son 3 simples pasos. Primero Escoge tu bono de bienvenida.',
    choises: {
      casino: {
        title: 'CASINO',
        description: '100 giros gratis',
        image: '/img/v2/icons/dice.webp',
      },
      sports: {
        title: 'PRONOSTICO',
        description: 'Freebet',
        image: '/img/v2/icons/ball.svg',
      },
    },
    descriptionForm: 'REGISTRATE EN',
    descriptionForm2: 'POWERBET',
  },
  authErrors: {
    account_not_linked: 'Este correo ya está registrado. Inicia sesión o verifica tu email antes de continuar con Google.',
    unable_to_link_account: 'No se pudo vincular la cuenta de Google. Intenta iniciar sesión con tu método original.',
    general: 'No pudimos completar el registro con Google. Intenta de nuevo.',
  },
};
